import client from '@util/api'
import { ContactModel, Values } from './typing'

export const saveContactInfo = async (contactInfo: Values) => {
  const request: ContactModel = {
    firstName: contactInfo.firstName.value,
    lastName: contactInfo.lastName.value,
    email: contactInfo.email.value,
    phone: contactInfo.phone.value,
    subject: contactInfo.subject.value,
    message: contactInfo.message.value,
    organization: contactInfo.organization.value,
    state: contactInfo.state.value,
    userRole: contactInfo.userRole.value,
    clinicianCount: contactInfo.clinicianCount.value,
    userPersona: contactInfo.userPersona.value,
  }
  const { data } = await client.post('/misc/contact_us', request)
  return data
}
export const getClientIpInfo = async () => {
  const { data } = await client.get('/misc/client-ip')
  return data
}
